import React from 'react';
import { CUSTOM_BRAND_ID } from './surveyCustomize';

function BrandSwitcher({ brands, selectedBrandId, onChange }) {
  return (
    <div className="survey-demo-controls">
      <label htmlFor="survey-brand-select">Preview as:</label>
      <select
        id="survey-brand-select"
        className="survey-brand-select"
        value={selectedBrandId}
        onChange={(e) => onChange(e.target.value)}
      >
        {brands.map((brand) => (
          <option key={brand.id} value={brand.id}>{brand.name}</option>
        ))}
        <option value={CUSTOM_BRAND_ID}>Customize...</option>
      </select>
    </div>
  );
}

export default BrandSwitcher;
